/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { GetAssignedTeamParams, TeamAssignment, TeamAssignmentRequest } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class TxTeamAssignmentController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags tx-team-assignment-controller
   * @name GetAssignedTeam
   * @request GET:/api/v1/spend-approval/tx/team
   */
  getAssignedTeam = (query: GetAssignedTeamParams, params: RequestParams = {}) =>
    this.http.request<TeamAssignment, any>({
      path: `/v1/spend-approval/tx/team`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getAssignedTeamPath = '/v1/spend-approval/tx/team'
  static getAssignedTeamMethod = 'GET'
  /**
   * No description
   *
   * @tags tx-team-assignment-controller
   * @name AssignTeam
   * @request POST:/api/v1/spend-approval/tx/team
   */
  assignTeam = (data: TeamAssignmentRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/spend-approval/tx/team`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static assignTeamPath = '/v1/spend-approval/tx/team'
  static assignTeamMethod = 'POST'
}
